import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { View } from 'react-native';
import { Typography } from '@hmsexp/component-library';
import { SparkLineStyling } from './style';
import { getLineChartSymbol, underscoreToText } from '../../utils';

const SparkLine = props => {
  const { index, data, label, subLabel, name, chartType = 'line', color } = props;

  const styles = SparkLineStyling();

  function getChartHeight() {
    switch (chartType) {
      case 'column':
        return 100;
      default:
        return 100;
    }
  }

  const getSparklineOptions = (name, data, color, index) => {
    const lastPointIndex = data.length - 1;
    const lastPointValue = data[lastPointIndex];
    const smallChartoption = {
      chart: {
        type: chartType,
        height: getChartHeight(),
        width: 200,
        height: chartType === 'line' ? 50 : 100
      },
      title: {
        text: ' '
      },
      xAxis: {
        visible: false
      },
      yAxis: {
        visible: false
      },
      tooltip: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      series: [
        {
          name: ' ',
          data,
          color: color,
          marker: {
            enabled: false
          },
          states: {
            hover: {
              enabled: false
            }
          },
          showInLegend: false
        }
      ]
    };
    if (chartType === 'line') {
      smallChartoption.series.push({
        type: 'scatter',
        name: ' ',
        data: [[lastPointIndex, lastPointValue]],
        marker: {
          radius: 5,
          fillColor: color,
          symbol: getLineChartSymbol(index)
        },
        states: {
          hover: {
            enabled: false
          }
        },
        enableMouseTracking: false,
        showInLegend: false
      });
    }
    return smallChartoption;
  };

  const options = getSparklineOptions(name, data, color, index);

  return (
    <View style={styles.container}>
      <View style={styles.innerContainer}>
        <View style={styles.chartContainer}>
          <Typography variant='button' fontWeightType='regular'>
            {underscoreToText(name)}
          </Typography>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </View>
        <View style={styles.dataContainer}>
          <View style={styles.dataFlexContainer}>
            <Typography variant='h5' fontWeightType='bold'>
              {label?.value}
            </Typography>
            <Typography textProps={{ style: styles.dataMicroText }} variant='micro' fontWeightType='regular'>
              {label?.label}
            </Typography>
          </View>
          <View style={styles.dataFlexContainer}>
            <Typography variant='button' fontWeightType='regular'>
              {subLabel?.value}
            </Typography>
            <Typography textProps={{ style: styles.dataMicroText }} variant='micro' fontWeightType='regular'>
              {subLabel?.label}
            </Typography>
          </View>
        </View>
      </View>
    </View>
  );
};

export default SparkLine;
